module.exports = __webpack_public_path__ + "img/Chevron-Down_16px_Icon_Disabled-Dark.9e326880.svg";